export function hideHeader() {
  return {
    type: '@ui/HIDE_HEADER',
  }
}
